import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { ASPECT_RATIO } from "@/react/components/constants";
import { CoverImageInput } from "@circle-react-uikit/CoverImageInput";
import { localeRoot } from "../../../../constants";
import { RenderImagePreview } from "./RenderImagePreview";

export const CoverImageField = () => {
  const { setValue } = useFormContext();
  const onImageAttachSuccess = () => {
    setValue(
      "paywall_customization_attributes.should_remove_cover_image",
      false,
    );
    setValue("paywall_customization_attributes.cover_image_url", null);
  };
  const onDelete = () => {
    setValue(
      "paywall_customization_attributes.should_remove_cover_image",
      true,
    );
    setValue("paywall_customization_attributes.cover_image_url", null);
  };

  return (
    <CoverImageInput
      showAddCoverBtn
      changeImageText={t("replace")}
      name="paywall_customization_attributes.cover_image"
      hideUnsplash={false}
      hideEmbedUrl={false}
      aspectRatio={ASPECT_RATIO.PAYWALL_COVER_IMAGE}
      renderer={RenderImagePreview}
      onImageAttachSuccess={onImageAttachSuccess}
      onDelete={onDelete}
      title=""
      customAspectRatioHelpText={t([
        localeRoot,
        "builder.default.cover_image.recommended_size",
      ])}
    />
  );
};
